export const CaseStatus = {
  Submitted: 'Case Submitted',
  AwaitingFolderGeneration: 'Awaiting Folder Generation Process',
  FolderGeneration: 'Folder Generation Process',
  FolderGenerationOk: 'Folder Generation Success',
  FolderGeneratioFailed: 'Folder Generation Failed',
  Segmentation: 'Segmentation Process',
  DoctorUpload: 'STATUS_DOCTOR_UPLOAD',
  InBraceCheck: 'STATUS_INBRACE_CHECK',
  ReviseSetup: 'Revise Setup',
  SetupReview: 'Setup Review',
  SetupUploadReady: 'Setup Ready for Upload',
  SetupConversion: 'Setup Conversion Process',
  SetupConversionFailed: 'Setup Conversion Failed',
  SetupReleaseReady: 'Setup Ready for Release',
  DoctorApproveOrReviseSetup: 'Doctor Approve or Revise Setup',
  DoctorProvideClarification: 'Doctor Provide Clarification',
  DoctorClarificationResolved: 'Doctor Clarification Resolved',
  ApplianceDesign: 'CAD Process',
  StageI: 'Stage I',
  StageII: 'Stage II',
  StageIII: 'Stage III',
  QualityControlReview: 'Quality Control Review',

  FilesChecking: 'InSmile Checking Files',
  SetupPreparing: 'InSmile Preparing Setup',
  StatusManufacturing: 'STATUS_MANUFACTURE',
  ManufacturingCase: 'InSmile Manufacturing Case',
  ProviderEdit: 'Provider Edit Review',
  IFSInConversion: 'Final Design in Conversion',
  IFSConversionFailed: 'Final Design Conversion Failed',
  IFSReadyForRelease: 'Final Design Ready for Release',
  IFSUpload: 'Final Design Upload',

  InBraceSetup: 'STATUS_INBRACE_SETUP',
  CaseShipped: 'Case Shipped',
  StatusShip: 'STATUS_SHIP',
  StatusHold: 'STATUS_HOLD',
  StatusUnhold: 'STATUS_UNHOLD',
  StatusCancel: 'STATUS_CANCEL',
  StatusUncancel: 'STATUS_UNCANCEL',
  StatusDoctorApproval: 'STATUS_DOCTOR_APPROVAL',
  Hold: 'Hold',
  Unhold: 'Unhold',
  Cancelled: 'Cancelled',
  Uncancelled: 'Uncancelled',
};

export const ECaseProcessStatus = {
  RevisionDraft: 1,
  RevisionDraftCancelled: 2,
  FolderJobFailedOnESLImport: 3,
  FolderJobFailedNoFilesForESLImport: 4,
};

export const AdjustedSetupStatus = {
  Initiated: 'Adjusted Setup Initiated',
  Uploaded: 'Adjusted Setup Zip Uploaded',
  Removed: 'Adjusted Setup Zip Upload Removed',
  Converting: 'Adjusted Setup Converting',
  Success: 'Adjusted Setup Conversion Success',
  Failed: 'Adjusted Setup Conversion Failed',
  Reprocess: 'Adjusted Setup Reprocess',
};

export const CaseHistoryStatus = {
  StartedRecordVerification: 'InSmile Started Records Verification',
  CompletedRecordVerification: 'InSmile Completed Records Verification',
  RecordsIncomplete: 'Records Incomplete',

  InbraceRequestedNewRecords: 'InSmile Requested New Records',
  ProviderUploadedNewRecords: 'Provider Uploaded New Records',

  InbraceStartedSmileDesign: 'InSmile Started Design',
  InbraceCompletedSmileDesign: 'InSmile Completed Design',

  InbraceStartedSmileDesignReview: 'Revision: InSmile Started Design Review',
  InbraceApprovedSmileDesignReview: 'Revision: InSmile Approved Design',

  ProviderRequestedRevision: 'Provider Requested Revision',
  ProviderApprovedDesign: 'Provider Approved Design',

  InbraceStartedFabrication: 'InSmile Started Case Fabrication',
  InbraceCompletedFabrication: 'InSmile Completed Case Fabrication',

  InbraceStartedClinicalReview: 'InSmile Initiated Clinical Review',
  InbraceCompletedClinicalReview: 'InSmile Completed Clinical Review',

  InbraceCaseOnHold: 'InSmile Placed Case on Hold',
  InbraceRequestedClarification: 'InSmile Requested Clarification',
  PendingDoctorClarification: 'Pending Doctor Clarification',
  InbraceResumed: 'InSmile Resumed',
};

export const SetupStatus = {
  Revised: {
    value: 'Revised',
    is: (target) => {
      return SetupStatus.Revised.value.toLowerCase() === target.toLowerCase();
    },
  },
  Released: {
    value: 'Released',
    is: (target) => {
      return SetupStatus.Released.value.toLowerCase() === target.toLowerCase();
    },
  },
  Rejected: {
    value: 'Rejected',
    is: (target) => {
      return SetupStatus.Rejected.value.toLowerCase() === target.toLowerCase();
    },
  },
  Approved: {
    value: 'Approved',
    is: (target) => {
      return SetupStatus.Approved.value.toLowerCase() === target.toLowerCase();
    },
  },
  InternallyRejected: {
    value: 'Internally Rejected',
    is: (target) => {
      return SetupStatus.InternallyRejected.value.toLowerCase() === target.toLowerCase();
    },
  },
  InternallyApproved: {
    value: 'Internally Approved',
    is: (target) => {
      return SetupStatus.InternallyApproved.value.toLowerCase() === target.toLowerCase();
    },
  },
  InBraceIFS: {
    value: 'InSmile IFS',
    is: (target) => {
      return SetupStatus.InBraceIFS.value.toLowerCase() === target.toLowerCase();
    },
  },
};
